"use client"

import { PrivyProvider } from "@privy-io/react-auth"
import { WagmiProvider } from "@privy-io/wagmi"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { useState, type PropsWithChildren } from "react"
import { getWagmiConfig, sourceChain, supportedChains } from "@/lib/config/wagmi"

const wagmiConfig = getWagmiConfig()

export function Providers({ children }: PropsWithChildren) {
  const [queryClient] = useState(() => new QueryClient())

  return (
    <PrivyProvider
      appId={process.env.NEXT_PUBLIC_PRIVY_APP_ID || ""}
      config={{
        loginMethodsAndOrder: {
          primary: ["wallet_connect_qr", "metamask"],
          overflow: [],
        },
        appearance: {
          theme: "dark",
          showWalletLoginFirst: true,
          walletList: ["metamask", "wallet_connect_qr"],
        },
        defaultChain: sourceChain,
        supportedChains: [...supportedChains],
        embeddedWallets: {
          ethereum: {
            createOnLogin: "off",
          },
        },
        walletConnectCloudProjectId:
          process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID,
      }}
    >
      <QueryClientProvider client={queryClient}>
        <WagmiProvider config={wagmiConfig}>
          {children}
        </WagmiProvider>
      </QueryClientProvider>
    </PrivyProvider>
  )
}
